import { ImpressionEvents } from '../../utils/events/impression';

export const ReportingChannelType = {
    IMPRESSION: {
        name: 'impression',
        events: ImpressionEvents,
    },
};
